// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Delegate-module__containerText___k_krM{display:-webkit-box;display:-ms-flexbox;display:flex;gap:5px}.Delegate-module__moniker___uWMFX{font-size:20px;text-transform:none}", "",{"version":3,"sources":["webpack://./src/pages/Sphere/pages/components/ActionBarContainer/components/Delegate/Delegate.module.scss"],"names":[],"mappings":"AAAA,wCACE,mBAAA,CAAA,mBAAA,CAAA,YAAA,CACA,OAAA,CAGF,kCACE,cAAA,CACA,mBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerText": "Delegate-module__containerText___k_krM",
	"moniker": "Delegate-module__moniker___uWMFX"
};
export default ___CSS_LOADER_EXPORT___;
